module.exports = __webpack_public_path__ + "img/kw.ae1006cd.svg";